import useSWR from "swr";
import { useCreateStripeAdminAxiosInstance } from "../../Auth/useCreateStripeAdminAxiosInstance.ts";
import { StripeOrderDTO } from "../../Stripe/StripeOrderDTO.ts";

export function useGetStripeOrder(orderId: string | undefined) {
  const { createAxiosInstance } = useCreateStripeAdminAxiosInstance();

  const { data, isLoading, error, mutate } = useSWR(
    orderId ? `/admin/orders/${orderId}` : null,
    async (url) => {
      const axiosInstance = createAxiosInstance();
      const { data } = await axiosInstance.get<StripeOrderDTO>(url);
      return data;
    },
  );

  return {
    order: data,
    isLoading,
    error,
    mutate,
  };
}
